import { createSlice, createAsyncThunk,PayloadAction } from '@reduxjs/toolkit';
import { sitesSerivces } from '../services';
import { Site } from '../interfaces';


const initialState = {
    sites: []
};

export const fetchSites = createAsyncThunk('sites/fetchSites', async () => {
  return sitesSerivces.getAll();
});

export const sitesSlice = createSlice({
  name: 'sites',
  initialState,
    reducers: { 
        addSite: (state,action:PayloadAction<Site>) => {
            let _sites = [...state.sites, action.payload];
            state.sites= _sites
        },
        deleteSite: (state, action: PayloadAction<Site[]>) => {
            let _sites = state.sites.filter(
            (site) => !action.payload.some((item) => item.id === site.id)
            );
        },
        updateSite: (state, action: PayloadAction<Site>) => {
            const _id = state.sites.findIndex((site)=>site.id === action.payload.id)
        },

  },
   
});



export const { addSite,deleteSite,updateSite } = sitesSlice.actions

export default sitesSlice.reducer





